import { render, staticRenderFns } from "./commonOrderList.vue?vue&type=template&id=2b877502&scoped=true"
import script from "./commonOrderList.vue?vue&type=script&lang=ts"
export * from "./commonOrderList.vue?vue&type=script&lang=ts"
import style0 from "./commonOrderList.vue?vue&type=style&index=0&id=2b877502&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b877502",
  null
  
)

export default component.exports